import { useEffect, useRef } from 'react';
const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
const useFocusTrap = (containerRef, onEscape) => {
    const previousFocusRef = useRef(null);
    const onEscapeRef = useRef(onEscape);
    onEscapeRef.current = onEscape;
    useEffect(() => {
        previousFocusRef.current = document.activeElement;
        const container = containerRef.current;
        if (!container)
            return;
        const heading = container.querySelector('h1, h2, h3, h4, h5, h6');
        if (heading) {
            heading.tabIndex = -1;
            heading.focus();
        }
        const handleKeyDown = (e) => {
            const dialogs = document.querySelectorAll('[role="dialog"]');
            if (container.getAttribute('role') === 'dialog' &&
                dialogs[dialogs.length - 1] !== container)
                return;
            if (e.key === 'Escape' && onEscapeRef.current) {
                e.stopPropagation();
                onEscapeRef.current();
                return;
            }
            if (e.key !== 'Tab')
                return;
            e.stopPropagation();
            const focusable = Array.from(container.querySelectorAll(FOCUSABLE)).filter((element) => element.tabIndex >= 0 &&
                !element.closest('[hidden]') &&
                element.getClientRects().length > 0);
            if (focusable.length === 0) {
                e.preventDefault();
                return;
            }
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            const active = document.activeElement;
            const isInList = Array.from(focusable).includes(active);
            if (e.shiftKey) {
                if (!isInList || active === first) {
                    e.preventDefault();
                    last.focus();
                }
            }
            else {
                if (!isInList || active === last) {
                    e.preventDefault();
                    first.focus();
                }
            }
        };
        container.addEventListener('keydown', handleKeyDown);
        return () => {
            container.removeEventListener('keydown', handleKeyDown);
            previousFocusRef.current?.focus();
        };
    }, [containerRef]);
};
export default useFocusTrap;
